import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import "../Form.css";
import useForm from "react-hook-form";
import vars from "../../utils/variables";

const ConfirmMedicalRecord = ({ history }) => {
  const id = history.location.state.id;
  const [error, setError] = useState(false);

  const { handleSubmit } = useForm();

  const handleFetch = () => {
    fetch(`${vars.server}/administration/acceptDeclarationOfAgreement/` + id, {
      method: "POST",
      body: JSON.stringify(),
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include"
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (result.success) {
          history.push("/adminrequests");
        } else {
          setError(result.message);
        }
      });
  };

  return (
    <form onSubmit={handleSubmit(handleFetch)} className="formForm">
      <h1>Patientenakte akzeptieren</h1>
      {error && <p className="errorMessage">Fehler: {error}</p>}
      <p>Um die Patientenakte zu akzeptieren, bestätigen Sie bitte mit "Patientenakte akzeptieren".</p>
      <br />
      <br />
      <input type="submit" value="Patientenakte akzeptieren" className="inputRLSubmit delete" />
    </form>
  );
};

export default withRouter(ConfirmMedicalRecord);
